<template>
  <button
    type="button"
    class="decision-list-card w-full text-left p-4 rounded-[10px] border transition-colors"
    :class="selected
      ? 'decision-list-card--selected'
      : 'decision-list-card--default'"
    :data-testid="`decision-list-card-${decision.id}`"
    @click="$emit('select', decision.id)"
  >
    <div class="flex items-center gap-2 mb-1.5">
      <span
        class="decision-list-card__status inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold shrink-0"
        :style="statusStyle"
      >
        {{ statusLabel }}
      </span>
      <span
        class="decision-list-card__due text-[12px] font-medium shrink-0 inline-flex items-center gap-0.5"
        :class="decision.isOverdue ? 'decision-list-card__due--overdue' : 'decision-list-card__due--normal'"
      >
        <i
          v-if="decision.isOverdue"
          class="pi pi-exclamation-triangle text-[10px]"
          aria-hidden="true"
        />
        {{ dueLine }}
      </span>
    </div>

    <p class="text-[13px] font-semibold text-[var(--color-dark)] mb-1 leading-snug">
      {{ decision.title }}
    </p>

    <p class="decision-list-card__meta text-[11px] mb-0.5">
      <span class="decision-list-card__label">{{ $t('UserProjects.decisions.card.decider') }}:</span>
      {{ deciderLabel }}
    </p>

    <p class="decision-list-card__meta text-[11px] m-0 leading-relaxed">
      <span class="decision-list-card__label">{{ $t('UserProjects.decisions.card.impact') }}:</span>
      {{ impactLine }}
    </p>
  </button>
</template>

<script>
import { DECISION_STATUS_STYLES, formatDecisionDate } from '@/utils/decisionDisplay';

export default {
  name: 'DecisionListCard',
  props: {
    decision: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    deciderLabel: {
      type: String,
      default: '—',
    },
  },
  emits: ['select'],
  computed: {
    statusStyle() {
      const style = DECISION_STATUS_STYLES[this.decision.status] || DECISION_STATUS_STYLES.open;
      return {
        backgroundColor: style.backgroundColor,
        color: style.color,
      };
    },
    statusLabel() {
      const key = DECISION_STATUS_STYLES[this.decision.status]?.labelKey || 'open';
      return this.$t(`ProjectManagement.decisions.status.${key}`);
    },
    dueLine() {
      return formatDecisionDate(this.decision.dueDate, this.$i18n.locale);
    },
    impactLine() {
      return this.decision.impactIfDelayed || '—';
    },
  },
};
</script>

<style scoped>
.decision-list-card {
  display: block;
  width: 100%;
  text-align: left;
  align-items: stretch;
  justify-content: flex-start;
  gap: 0;
  cursor: pointer;
  font: inherit;
}

.decision-list-card--default {
  border-color: #e5e5e5;
  background-color: #fff;
}

.decision-list-card--default:hover {
  background-color: #fafafa;
}

.decision-list-card--selected {
  border-color: #e4821a;
  background-color: #fdf0e6;
}

.decision-list-card__label {
  color: #ababab;
}

.decision-list-card__meta {
  color: #6b6b6b;
}

.decision-list-card__due--overdue {
  color: #ef4444;
}

.decision-list-card__due--normal {
  color: #6b6b6b;
}
</style>
